import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    d: 'M4.26303 3.635C3.91232 3.9857 3.91232 4.5543 4.26303 4.905L8.62803 9.27V13H11.628V22L15.208 15.86L18.7223 19.3658C19.0735 19.7162 19.6422 19.7158 19.993 19.365C20.3437 19.0143 20.3437 18.4457 19.993 18.095L5.53303 3.635C5.18232 3.2843 4.61373 3.2843 4.26303 3.635ZM18.628 10H14.628L18.628 2H8.62803V4.18L17.088 12.64L18.628 10Z',
                    fill: '#82869E',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const FlashOffFilled = React.forwardRef(IconComponent);
FlashOffFilled.displayName = 'FlashOffFilled';

export { FlashOffFilled };
